"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicSite = exports.getPublicSites = exports.putSiteAccessibility = exports.deleteSitePermission = exports.postSitePermission = exports.delSite = exports.postSite = exports.putSite = exports.getSite = exports.getSites = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var sitesAuthorizedPath = root_1.organizationManagementAuthorized + '/sites/';
var sitesPublicPath = root_1.organizationManagementPublic + '/sites/';

var getSites = function getSites(authentication, queryParameters) {
  return common_1.get(authentication, sitesAuthorizedPath, queryParameters);
};

exports.getSites = getSites;

var getSite = function getSite(authentication, id) {
  return common_1.get(authentication, sitesAuthorizedPath + id);
};

exports.getSite = getSite;

var putSite = function putSite(authentication, site) {
  return common_1.put(authentication, sitesAuthorizedPath + site.id, site);
};

exports.putSite = putSite;

var postSite = function postSite(authentication, site) {
  return common_1.post(authentication, sitesAuthorizedPath, site);
};

exports.postSite = postSite;

var delSite = function delSite(authentication, id) {
  return common_1.del(authentication, sitesAuthorizedPath + id);
};

exports.delSite = delSite;

var postSitePermission = function postSitePermission(authentication, id, permission) {
  return common_1.postPermission(authentication, sitesAuthorizedPath, id, permission);
};

exports.postSitePermission = postSitePermission;

var deleteSitePermission = function deleteSitePermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, sitesAuthorizedPath, id, permissionId);
};

exports.deleteSitePermission = deleteSitePermission;

var putSiteAccessibility = function putSiteAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, sitesAuthorizedPath, id, accessibility);
};

exports.putSiteAccessibility = putSiteAccessibility;

var getPublicSites = function getPublicSites(authentication, queryParameters) {
  return common_1.get(authentication, sitesPublicPath, queryParameters);
};

exports.getPublicSites = getPublicSites;

var getPublicSite = function getPublicSite(authentication, id) {
  return common_1.get(authentication, sitesPublicPath + id);
};

exports.getPublicSite = getPublicSite;